import React from 'react';
import vitelwireless2 from "../landing-images/newLogo.png";
// import vitelwireless from "../assets/"
import "./headerStyle.css";
const LandingHeader = () => {
  return (
    <div>
      <div className='top-nav'>
        {/* <a href='$'>Sales </a> */}
        <a href='#'> | for support and enquiry call: 0803777-3444 </a>
        {/* <a href='#'> | Request Quote </a>
        <a href='#'> | Signup </a>
        <a href='#'> | Login</a> */}
      </div>

      <div className='menu-items'>
        <div className='logo'>
          <a href='/#hero'>
            <img src={vitelwireless2} alt='logo' />
          </a>
        </div>
        {/* <div className='menu'>
          <a href='/'> SOLUTIONS </a>
          <a href='/#product'> PRODUCTS </a>
          <a href='/#company'> COMPANY</a>
          <a href='/#partners'> PARTNERS </a>
          <a href='/#management'> MANAGEMENT TEAM</a>
        </div> */}

        {/* <MobileMenu isMobile={true} closeMobileMenu={props.closeMobileMenu} /> */}
      </div>
    </div>
  );
};

export default LandingHeader;
